const ArrowRightUp = () => (
    <svg width={28} height={32} fill="none">
        <path
            stroke="#C3CCD9"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M1 30.5h6.5c6.075 0 11-4.925 11-11V1m0 0-9 9.5m9-9.5 8.5 9.5"
        />
    </svg>
);
export default ArrowRightUp;
